module.exports = __webpack_public_path__ + "static/media/RHOutSwingDark.93eec28a.svg";